module.exports = "pegasus/assets/tech/realty/104.png";